CustomTC.define('jquery/traversing/var/rneedsContext',[
	"../../core",
	"../../selector"
], function( jQuery ) {
	return jQuery.expr.match.needsContext;
});

